import * as React from 'react';
/**
 *
 * Original name: thumbs up
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A308
 *
 */
export const ThumbsUpPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M51.836 28.139A5.987 5.987 0 0 0 47.244 26h-7.571l1.227-4.178A10.001 10.001 0 0 0 31.308 9h-2.75l-4.045 12.134c-.132.401-.39.75-.734.994l-4.9 3.5a1.986 1.986 0 0 1-1.161.372H11v19.148l10.657 6.217A12.012 12.012 0 0 0 27.7 53h16.936a5.988 5.988 0 0 0 5.911-4.972l2.608-15a5.984 5.984 0 0 0-1.319-4.889Zm-2.622 4.2-2.608 15A2 2 0 0 1 44.636 49H27.7a8.008 8.008 0 0 1-4.031-1.09L15 42.852V30h2.718a5.973 5.973 0 0 0 3.487-1.117l4.9-3.5a5.96 5.96 0 0 0 2.204-2.983l3.132-9.4a6 6 0 0 1 5.623 7.692L34.327 30h12.917a2 2 0 0 1 1.971 2.343l-.001-.004Z", fill: "currentColor" })));
